import { Link } from "wouter";
import { ReactNode } from "react";
// import { Logo } from "@/components/ui/logo/logo";
import { ContextFlowSteps } from "../ui/flow-steps";
import { RectangleGroupIcon } from "@heroicons/react/24/solid";
import { ContextPackDropdown } from "@/features/contexts/components/context-pack-dropdown";
import { useGetContextPack } from "@/api/studio/contexts/queries";
// import { StudyFlowSteps } from "../ui/study-flow-steps";

/* Prop Types */
interface CreateContextsLayoutProps {
  children: ReactNode;
  currentStep: string;
  contextPackId: string;
}

/*
 * StudiesLayout component
 * This layout wraps the study creation flow in the application
 */
export const CreateContextsLayout = ({ children, contextPackId, currentStep }: CreateContextsLayoutProps) => {
  /* Queries */
  const { data: contextPack, isLoading: isContextPackLoading } = useGetContextPack(contextPackId);

  /* Render */
  return (
    <div className="grow flex flex-col gap-4 px-7 py-4 max-h-screen">
      {/* Header */}
      <header className="min-h-12 flex items-center pl-2">
        <Link href="/contexts" className="flex items-center gap-2">
          <RectangleGroupIcon className="size-5" />
        </Link>

        {/* Asset steps */}
        <ContextFlowSteps contextPackId={contextPackId} currentStep={currentStep} />

        {/* Only show the dropdown if it isn't a dragonfly pack */}
        {!isContextPackLoading && contextPack && !contextPack.isDragonfly && (
          <div className="ml-auto">
            <ContextPackDropdown contextPack={contextPack} />
          </div>
        )}
      </header>
      {/* Content */}
      {children}
    </div>
  );
};
